<!--  -->
<template>
  <div style="width: 1000px;margin: 70px auto;">
      <bar></bar>
      <div style="width: 1000px;height: 30px; margin-top: 20px;;border-bottom: 1px solid #000000;"><span style="font-size: 14px;float: left">首页/订单详情</span></div>

      <div style="margin:25px 0px;">
			<div style="margin: 25px auto;text-align: left;">
				<span style="font-size: 14px;">
					活动名称：
					<span style="font-size: 13px;">{{activityName}}</span>
				</span>
			</div>
			<div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					用户姓名：
					<span style="font-size: 13px;">{{staffName}}</span>
				</span>
			</div>
            <div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					当前送货地址：
					<span style="font-size: 13px;">{{deliveryAddress}}</span>
				</span>
			</div>
            <div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					联系电话：
					<span style="font-size: 13px;">{{phone}}</span>
				</span>
			</div>
            <div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					订单编号：
					<span style="font-size: 13px;">{{orderCode}}</span>
				</span>
			</div>
            <div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					订单总福豆：
					<span style="font-size: 13px;">{{orderAmount}}</span>
				</span>
			</div>
            <div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					订单日期：
					<span style="font-size: 13px;">{{orderTime}}</span>
				</span>
			</div>
            <div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					支付方式：
					<span style="font-size: 13px;">{{paymentMethodName}}</span>
				</span>
			</div>
            <div style="margin: 25px auto;text-align: left">
				<span style="font-size: 14px;">
					订单状态：
					<span style="font-size: 13px;">{{orderStatusName}}</span>
				</span>
			</div>
		</div>

      <div>
			<el-table :data="list" border style="width: 100%;">
				<el-table-column type="index" align="center" label='No.' min-width="50">
            	</el-table-column>
				<el-table-column align="center" label='SKU code' min-width="120">
					<template slot-scope="scope">
					{{scope.row.skuCode}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='商品名称' min-width="150">
					<template slot-scope="scope">
					{{scope.row.productName}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='图片' min-width="100">
					<template slot-scope="scope">
					<img style="width:40px;height:40px;" :src="$store.getters.imageUrl + '/' + scope.row.productImgPath" alt="" />
					</template>
				</el-table-column>
				<el-table-column align="center" label='福豆' min-width="100">
					<template slot-scope="scope">
					{{scope.row.unitPrice}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='数量' min-width="150">
					<template slot-scope="scope">
					{{scope.row.buyCount}}
					</template>
				</el-table-column>
				<el-table-column align="center" label='总福豆' min-width="120">
					<template slot-scope="scope">
					{{scope.row.buyCount*scope.row.unitPrice}}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="height:160px;margin-top: 50px;">
				    <el-button @click="toOrder" type="primary">返回</el-button>
			</div>
  </div>
</template>

<script>
import bar from '@/components/bar.vue';
import { orderInfo } from '../api/service'

export default {
  data () {
    return {
        id: '',
        list: null,
        activityName: '',
        staffName: '',
        deliveryAddress: '',
        phone: '',
        orderCode: '',
        orderAmount: '',
        orderTime: '',
        paymentMethodName: '',
        orderStatusName: ''
    };
  },
  components: {
      bar
  },
  created() {
		this.id = this.$route.query.id
		this.fetchData()
  },
  methods: {
      fetchData () {
           const params = {
               id: this.id
           }
			orderInfo(params).then((response) => {
				if (response.data.success === true) {
                    this.list = response.data.data.orderProducts
                    this.activityName = response.data.data.activityName
                    this.staffName = response.data.data.staffName
                    this.deliveryAddress = response.data.data.deliveryAddress
                    this.phone = response.data.data.phone
                    this.orderCode = response.data.data.orderCode
                    this.orderAmount = response.data.data.orderAmount
                    this.orderTime = response.data.data.orderTime
                    this.paymentMethodName = response.data.data.paymentMethodName
                    this.orderStatusName = response.data.data.orderStatusName
				} 
				
			}).catch(() => {
			})
		},
		toOrder () {
			this.$router.push({ path: 'meorder' })
		}
  }
}

</script>
<style scoped="">
.clearfix:after{
	content: '';
	display: block;
	clear: both;
}
.top-bar {
	position: fixed;
	top: 0;
	bottom: auto;
	left: 0;
	right: auto;
	width: 100%;
}
.top-color {
	height: 40px;
	background: #be0f34;
}
.top-color img {
	width: 209px;
	margin-top: 8px;
}
.confirm-border {
	background-color: orange;
	width: 111px;
	height: 34px;
	z-index: 100;
	margin-left: 296px;
}
.confirm-border span {
	line-height: 35px;
	text-align: center;
	color: white;
}
.order-box {
	margin: 42px auto;
	width: 600px;
}
.order-box span {
	font-size: 14px;
	color: #606266;
}
.confirm-button {
	float: right;
	margin-top: 120px;
}
</style>